function Editorial({ title, subtitle }) {
  return (
    <div className='article editorial'>
      <div className='container'>
        <h2>
          <div className='subtitle'>{subtitle}</div>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          {/* <span dangerouslySetInnerHTML={{ __html: title }} /> */}
        </h2>
        <div className='content'>
          <p>政治问题无疑是润的触发点。国家机器不断增强控制力，宣传部门开足马力给民众灌迷魂汤，随着结构性问题的累积，权益受到挤压的人越来越多。特别是疫情期间的极端封控措施让很多人感到绝望。作为极权社会下原子化的个体，逃离也许是唯一的理性选择。</p>
          <p>然而，要从一个土生土长的地方移植到另一个陌生的环境，谈何容易？新移民不但要解决最基础的生存需求和身份合法性，还需要形成新的价值主体性和社群认同，这往往会造成新的物质和精神困扰。</p>
          <p>让人感到有希望的是，一些接受过良好人文教育的年轻人开始重新政治化，他们在肉身获得自由后正在找回关注、介入中国事务的空间和能动性。</p>
          <a
            href="https://www.wainao.me/wainao-reads/run-passive-resistance-social-movement-05012023"
            target='_blank'
            rel="noreferrer" >阅读全文</a>
        </div>
      </div>
    </div>
  );
}

export default Editorial;
